// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#Product-Options-Container{padding-bottom:1.25rem}", "",{"version":3,"sources":["webpack://src/Components/PageElements/Products/Styles/_ProductOptionsList.scss"],"names":[],"mappings":"AAAA,2BACE,sBAAA","sourcesContent":["#Product-Options-Container {\n  padding-bottom: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
